"use client"

import { MuteIcon } from "@/app/icons/mute"
import { UnmuteIcon } from "@/app/icons/unmute"
import { Button, cn } from "@rarible_int/anaconda_ui_components"

type GachaRevealMuteButtonProps = {
  muted: boolean
  onToggle: () => void
  className?: string
}

export function GachaRevealMuteButton({
  muted,
  onToggle,
  className,
}: GachaRevealMuteButtonProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn(
        "size-10 rounded-full border border-white/15 bg-black/45 text-white backdrop-blur-sm hover:bg-black/60 hover:text-white",
        className,
      )}
      aria-label={muted ? "Unmute reveal sound" : "Mute reveal sound"}
      aria-pressed={muted}
      onClick={onToggle}
    >
      {muted ? (
        <UnmuteIcon className="size-5 opacity-60" />
      ) : (
        <MuteIcon className="size-5" />
      )}
      <span className="sr-only">{muted ? "Unmute sound" : "Mute sound"}</span>
    </Button>
  )
}
